import {
  MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetCommentUserTypeFilterRequest,
  MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetCountRequest,
  MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetCountryFilterRequest,
  MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetCustomTagsFilterRequest,
  MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetDomainStatusFilterRequest,
  MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetWebsiteDetailRequest,
  MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetWebsiteListRequest,
  MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetWebsiteReportedDetailRequest,
} from '~/swagger/data-contracts';

const DOMAIN_NAMES_QUERY_KEY = 'domainNames';

const createQueryKey = <T>(base: readonly unknown[], key: string, request?: T) => {
  const baseKey = [...base, key] as const;
  return request ? ([...baseKey, request] as const) : baseKey;
};

export const domainNamesQueryKeys = {
  all: () => [DOMAIN_NAMES_QUERY_KEY] as const,
  filter: {
    all: () => [DOMAIN_NAMES_QUERY_KEY, 'filter'] as const,
    country: (request?: MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetCountryFilterRequest) =>
      createQueryKey(domainNamesQueryKeys.filter.all(), 'country', request),
    commentUserType: (request?: MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetCommentUserTypeFilterRequest) =>
      createQueryKey(domainNamesQueryKeys.filter.all(), 'comment-user-type', request),
    customTag: (request?: MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetCustomTagsFilterRequest) =>
      createQueryKey(domainNamesQueryKeys.filter.all(), 'custom-tag', request),
    domainStatus: (request?: MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetDomainStatusFilterRequest) =>
      createQueryKey(domainNamesQueryKeys.filter.all(), 'domain-status', request),
  },
  count: (request?: MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetCountRequest) =>
    createQueryKey(domainNamesQueryKeys.all(), 'count', request),
  list: (request?: MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetWebsiteListRequest) =>
    createQueryKey(domainNamesQueryKeys.all(), 'list', request),
  details: (request?: MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetWebsiteDetailRequest) =>
    createQueryKey(domainNamesQueryKeys.all(), 'details', request?.website_id),
  reportedDetails: (request?: MonitoringWebsiteDomainWebsiteDomainNamesProtocolsGetWebsiteReportedDetailRequest) =>
    createQueryKey(domainNamesQueryKeys.all(), 'details-reported', request?.website_id),
  headerList: () => createQueryKey(domainNamesQueryKeys.all(), 'header-list'),
};

export type DomainNamesQueryKeys = typeof domainNamesQueryKeys;
